import { useState, useEffect } from "react";
import useResizeObserver from "@react-hook/resize-observer";

const useAppSize = (target) => {
  const [appSize, setAppSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (target && target.current) {
      const { width, height } = target.current.getBoundingClientRect();
      setAppSize({ width, height });
    }
  }, [target]);

  useResizeObserver(target, (entry) => {
    const { width, height } = entry.contentRect;
    setAppSize({ width, height });
  });

  return appSize;
};

export default useAppSize;
